// extracted by mini-css-extract-plugin
module.exports = {"desktopInputRoot":"TopbarSearchForm_desktopInputRoot__26QCl","languageSelect":"TopbarSearchForm_languageSelect__YJqE1","searchLink":"TopbarSearchForm_searchLink__1piOj"};